export enum CheckoutIntegrationStatus {
  SENT = 'sent',
  RECEIVED = 'received',
  VERIFIED = 'verified',
  FINALIZED = 'finalized',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
  POSTPONED = 'postponed',
}
